// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

// const Banner = ({ image, heading }) => {
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const handleResize = () => {
//       setWindowWidth(window.innerWidth);
//     };

//     window.addEventListener("resize", handleResize);
//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   const containerStyle = {
//     backgroundImage: `url(${image})`,
//     backgroundSize: "cover",            // Ensures the image covers the entire container
//     backgroundPosition: "center center", // Centers the image vertically and horizontally
//     backgroundRepeat: "no-repeat",       // Prevents the image from repeating
//     backgroundAttachment: "fixed",      // Makes the background fixed for a parallax effect (optional)
//     height: "90vh",                      // Sets the height to 90% of the viewport height
//     width: "100%",                       // Ensures full width
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "flex-start",
//     textAlign: "left",
//     flexDirection: "column",
//     paddingLeft: windowWidth > 768 ? "100px" : "10%",
//     paddingTop: "5%",
//     overflow: "hidden",                  // Prevents content overflow on smaller screens
//   };
  

//   const textContainerStyle = {
//     maxWidth: windowWidth > 1200 ? "40%" : "80%", // Heading and button end halfway across on large screens
//   };

//   const headingStyle = {
//     fontFamily: "Poppins, system-ui",
//     fontSize: windowWidth > 1200 ? "3.5rem" : windowWidth > 768 ? "3rem" : windowWidth > 480 ? "2rem" : "1.5rem",
//     fontWeight: "700",
//     color: "#ffffff",
//     margin: "0 0 20px 0", // Space between heading and button
//   };

//   const buttonStyle = {
//     backgroundColor: "#7ed3f7",
//     color: "white",
//     padding: "10px 20px",
//     border: "none",
//     borderRadius: "5px",
//     fontSize: "1rem",
//     fontFamily: "Poppins, system-ui",
//     cursor: "pointer",
//     transition: "background-color 0.3s ease",
//     marginTop: "20px",
//   };

//   const buttonHoverStyle = {
//     backgroundColor: "#6ac2e4",
//   };

//   return (
//     <div style={containerStyle}>
//       <div style={textContainerStyle}>
//         <h4 style={headingStyle}>{heading}</h4>
//         <button
//           style={buttonStyle}
//           onMouseEnter={(e) => (e.target.style.backgroundColor = buttonHoverStyle.backgroundColor)}
//           onMouseLeave={(e) => (e.target.style.backgroundColor = buttonStyle.backgroundColor)}
//           onClick={() => navigate("/contact#contactusform")}
//         >
//           Contact Us
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Banner;
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Banner = ({ image, heading }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* === HERO BACKGROUND + LAYOUT (left-aligned like Teamcenter) === */
  const containerStyle = {
    position: "relative",
    backgroundImage: `url(${image})`,
    backgroundSize: "cover",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    height: "90vh",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",      // ⬅️ put content to the left
    alignItems: "center",              // ⬅️ vertically center
    paddingLeft: windowWidth > 768 ? "8vw" : "8%",
    paddingRight: "8vw",
    overflow: "hidden",
  };

  const overlayStyle = {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(90deg, rgba(2,7,29,0.55) 0%, rgba(2,7,29,0.35) 40%, rgba(2,7,29,0.0) 100%)",
    pointerEvents: "none",
  };

  const textContainerStyle = {
    position: "relative",
    zIndex: 1,
    maxWidth: windowWidth > 1200 ? "38%" : "70%",
  };

  const headingStyle = {
    fontFamily: "Poppins, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize:
      windowWidth > 1200
        ? "3.6rem"
        : windowWidth > 768
        ? "3rem"
        : windowWidth > 480
        ? "2.3rem"
        : "1.9rem",
    fontWeight: 700,
    color: "#ffffff",
    letterSpacing: "0.03em",
    lineHeight: 1.1,
    margin: "0 0 26px 0",
    textShadow: "0 16px 32px rgba(0, 0, 0, 0.8)",
  };

  const buttonBaseStyle = {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "12px 34px",
    borderRadius: "999px",
    border: "2px solid #00f0ff",
    background: "rgba(0, 0, 0, 0.8)",
    color: "#ffffff",
    fontFamily: "Poppins, system-ui, sans-serif",
    fontWeight: 600,
    textTransform: "uppercase",
    fontSize: "0.9rem",
    letterSpacing: "0.08em",
    cursor: "pointer",
    marginTop: "8px",
    boxShadow:
      "0 0 0 1px rgba(0, 240, 255, 0.4), 0 0 18px rgba(0, 240, 255, 0.9)",
    transition: "all 0.18s ease",
    textDecoration: "none",
    outline: "none",
  };

  const buttonHoverExtra = {
    transform: "translateY(-2px) scale(1.02)",
    background: "rgba(0, 0, 0, 0.95)",
    borderColor: "#77ffff",
    boxShadow:
      "0 0 0 1px rgba(0, 240, 255, 0.7), 0 0 26px rgba(0, 240, 255, 1)",
  };

  const buttonStyle = isHovered
    ? { ...buttonBaseStyle, ...buttonHoverExtra }
    : buttonBaseStyle;

  return (
    <div style={containerStyle}>
      <div style={overlayStyle} />
      <div style={textContainerStyle}>
        <h4 style={headingStyle}>{heading}</h4>
        <button
          style={buttonStyle}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => navigate("/contact#contactusform")}
        >
          Contact Us
        </button>
      </div>
    </div>
  );
};

export default Banner;
